export default __webpack_public_path__ + "static/N0059-8bb00eb5aab894fc57fc5bf681a95f80.png";